import React from 'react';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { HedgehogLogo } from '../../../components/brand/HedgehogLogo';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';

interface InviteErrorCardProps {
  loadError: string;
}

export const InviteErrorCard: React.FC<InviteErrorCardProps> = ({ loadError }) => {
  return (
    <div className="min-h-screen bg-cf-bg flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="flex justify-center mb-3">
          <HedgehogLogo size={42} />
        </div>
        <h2 className="text-xl font-bold text-cf-textPrimary">
          Invitation Expired or Invalid
        </h2>
      </div>

      <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="bg-cf-surface py-8 px-6 border-cf-border shadow-xl rounded-lg sm:px-10 text-center space-y-4">
          <div className="p-3 rounded bg-rose-500/10 border border-rose-500/30 text-xs text-rose-600 dark:text-rose-400 flex items-start gap-2.5 text-left font-medium">
            <AlertCircle size={16} className="flex-shrink-0 mt-0.5 text-rose-600 dark:text-rose-400" />
            <span>{loadError}</span>
          </div>
          <p className="text-xs text-cf-textSecondary">
            If you already have an account or accepted this invite previously, please sign in.
          </p>
          <div className="pt-2">
            <Button
              to="/login"
              variant="primary"
              size="sm"
              fullWidth
              rightIcon={<ArrowRight size={14} />}
            >
              Go to Sign In
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};
